/** Bump when Terms of Service or Privacy Policy change materially (sync with onboarding consent records). */
export const TERMS_OF_SERVICE_VERSION = '2026-04-21';
export const PRIVACY_POLICY_VERSION = '2026-04-21';
